import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
} from '@mui/material';

export default function Header() {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const servicesMenuOpen = Boolean(anchorEl);

  const handleServicesToggle = (event) => {
    if (servicesMenuOpen) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const links = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About' },
    { to: '/resources', label: 'Resources' },
    { to: '/contact', label: 'Contact' },
    { to: '/privacy', label: 'Privacy' },
    { to: '/faq', label: 'FAQ' },
  ];

  // Services should appear after the About link in the navigation bar
  const preServiceLinks = links.slice(0, 2);
  const postServiceLinks = links.slice(2);

  const serviceLinks = [
    { to: '/services/free-ai-assessment', label: 'Free Assessment' },
    { to: '/services/rapid-ai-automation-sprint', label: 'Automation Sprint' },
    { to: '/services/ai-readiness-assessment', label: 'AI Readiness' },
    { to: '/services/ai-policy-development', label: 'AI Policy' },
    { to: '/services/end-to-end-ai-consulting', label: 'AI Consulting' },
  ];

  const logoUrl = process.env.PUBLIC_URL + '/assets/branding/re-logo-square.png';

  return (
    <AppBar position="static" color="primary">
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', my: 1 }}>
          <img src={logoUrl} alt="Robinson Engineering logo" style={{ height: 32, marginRight: 8 }} />
          <Typography variant="h6" color="inherit">
            Robinson Engineering
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
          {preServiceLinks.map(({ to, label }) => {
            const active = location.pathname === to;
            return (
              <Button
                key={to}
                component={RouterLink}
                to={to}
                color={active ? 'secondary' : 'inherit'}
                variant={active ? 'contained' : 'text'}
                sx={{ textTransform: 'none' }}
              >
                {label}
              </Button>
            );
          })}
          <Button
            color={location.pathname.startsWith('/services') ? 'secondary' : 'inherit'}
            variant={location.pathname.startsWith('/services') ? 'contained' : 'text'}
            sx={{ textTransform: 'none' }}
            onClick={handleServicesToggle}
          >
            Services
          </Button>
          {postServiceLinks.map(({ to, label }) => {
            const active = location.pathname === to;
            return (
              <Button
                key={to}
                component={RouterLink}
                to={to}
                color={active ? 'secondary' : 'inherit'}
                variant={active ? 'contained' : 'text'}
                sx={{ textTransform: 'none' }}
              >
                {label}
              </Button>
            );
          })}
          <Menu
            anchorEl={anchorEl}
            open={servicesMenuOpen}
            onClose={handleMenuClose}
            MenuListProps={{
              sx: { backgroundColor: 'background.paper', color: 'primary.main' },
            }}
          >
            {serviceLinks.map(({ to, label }) => (
              <MenuItem
                key={to}
                component={RouterLink}
                to={to}
                onClick={handleMenuClose}
              >
                {label}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
